import { Component, OnInit, OnDestroy } from "@angular/core";
//import { Subscription } from 'rxjs';

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { SchoolService } from "../../../shared/services/school.service";
import { UserService } from "../../../shared/services/user.service";

import { DataService_AlertMaintenance } from "./shared/data.service";
import { SchoolInfo } from "./shared/SchoolInfo";
import { wsAlertMaintenanceAlertInfo } from "./shared/wsAlertMaintenanceAlertInfo";
import { wsAlertMaintenanceToggleActiveParm } from "./shared/wsAlertMaintenanceAlertInfo";
import { wsAlertMaintenanceBroadcastAlertUpdateValidateParm } from "./shared/wsAlertMaintenanceAlertInfo";

import { AddBroadcastAlertComponent } from "./addbroadcastalert/addbroadcastalert.component";
import { EditBroadcastAlertComponent } from "./editbroadcastalert/editbroadcastalert.component";
import { AddEditEventAlertComponent } from "./addediteventalert/addediteventalert.component";
import { AddEditIncidentAlertComponent } from "./addeditincidentalert/addeditincidentalert.component";
import { EditSpecialAlertComponent } from "./editspecialalert/editspecialalert.component";

import { ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-root",
	templateUrl: "./alertmaintenance.component.html",
	styleUrls: ["./alertmaintenance.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class AlertMaintenanceComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterActive", { static: false }) public filterActive: Dropdown;
	@ViewChild("filterAlertTypeDesc", { static: false })
	public filterAlertTypeDesc: Dropdown;
	@ViewChild("filterApplied", { static: false })
	public filterApplied: Dropdown;
	@ViewChild("filterDefinedByDesc", { static: false })
	public filterDefinedByDesc: Dropdown;

	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_AlertMaintenance,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	Alert List
	public lstAlert: wsAlertMaintenanceAlertInfo[] = [];
	public SelectedAlert: wsAlertMaintenanceAlertInfo;

	//	Filters
	public lstActives: any = [];
	public lstAlertTypeDescs: any = [];
	public lstApplieds: any = [];
	public lstrDefinedByDescs: any = [];

	//	Alert Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.LoadSchoolList();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID > 0) {
			this.isBusy = true;
			this.dataService
				.AlertMaintenanceAlertSelectList(this.SelectedSchool.SchoolID)
				.subscribe((data) => this.AlertMaintenanceAlertSelectList_Complete(data));
		} else {
			this.lstAlert = [];
			this.SelectedAlert = null;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceAlertSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceAlertSelectList_Complete(data: any) {
		this.SelectedAlert = null;
		this.lstAlert = data;

		//
		//	Set Filter Lists
		//
		this.lstActives = Array.from(new Set(this.lstAlert.map((item: any) => item.ActiveDesc)));
		this.lstAlertTypeDescs = Array.from(new Set(this.lstAlert.map((item: any) => item.AlertTypeDesc)));
		this.lstApplieds = Array.from(new Set(this.lstAlert.map((item: any) => item.Applied)));
		this.lstrDefinedByDescs = Array.from(new Set(this.lstAlert.map((item: any) => item.DefinedByDesc)));

		//
		//	Set Filter Defaults
		//
		this.onSetFilterDefaults();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "AlertDesc", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFilterDefaults() {
		this.mydt.filters.ActiveDesc["value"] = "Yes"; // Default To 'Yes'
		this.mydt.filters.AlertTypeDesc["value"] = null; // Default To 'Any'
		this.mydt.filters.Applied["value"] = null; // Default To 'Any'
		this.mydt.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleActive() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		if (this.SelectedAlert == null) {
			this.ErrorMessage = "Please select an alert to toggle Active status.";
			return;
		}

		if (this.SelectedAlert.DefinedByID == 4 && this.user.UserLevelID != 1) {
			this.ErrorMessage = "Only district level users can toggle Active status on district level alerts.";
			return;
		}

		if (this.SelectedAlert.DefinedByID == 1 || this.SelectedAlert.DefinedByID == 2) {
			// System or Import
			this.ErrorMessage = "You cannot toggle Active status on System or Import level alerts.";
			return;
		}

		let parm: wsAlertMaintenanceToggleActiveParm = {
			UserID: this.user.userID,
			AlertID: this.SelectedAlert.AlertID,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceToggleActive(parm).subscribe((data) => this.AlertMaintenanceToggleActive_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceToggleActive_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceToggleActive_Complete(data: any) {
		this.ErrorMessage = data[0];
		this.isBusy = false;

		//
		//	Refresh Q
		//
		if (this.ErrorMessage.length == 0) {
			this.onRefresh();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowDblClick
	//
	//-----------------------------------------------------------------------------------------------------
	onRowDblClick(item: any) {
		this.onEdit();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEdit
	//
	//-----------------------------------------------------------------------------------------------------
	onEdit() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		if (this.SelectedAlert == null) {
			this.ErrorMessage = "Please select an alert to edit.";
			return;
		}

		if (this.SelectedAlert != null && this.SelectedAlert.AlertID > 0) {
			//
			// Event Alert
			//
			if (this.SelectedAlert.AlertTypeID == 1) {
				//
				//	Display Edit Popup
				//
				let popup_header = "Edit Event Alert";

				var ref = this.dialogService.open(AddEditEventAlertComponent, {
					header: popup_header,
					width: "880px",
					data: {
						UserID: this.user.userID,
						UserLevelID: this.user.UserLevelID,
						SchoolID: this.SelectedAlert.SchoolID,
						AlertID: this.SelectedAlert.AlertID,
						isAdd: false,
					},
				});

				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh Q
						//
						this.onRefresh();
					}
				});
			}

			//
			// Incident Alert
			//
			if (this.SelectedAlert.AlertTypeID == 2) {
				//
				//	Display Edit Popup
				//
				let popup_header = "Edit Incident Alert";

				var ref = this.dialogService.open(AddEditIncidentAlertComponent, {
					header: popup_header,
					width: "880px",
					data: {
						UserID: this.user.userID,
						UserLevelID: this.user.UserLevelID,
						SchoolID: this.SelectedAlert.SchoolID,
						AlertID: this.SelectedAlert.AlertID,
						isAdd: false,
					},
				});

				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh Q
						//
						this.onRefresh();
					}
				});
			}

			//
			// Special Alert
			//
			if (this.SelectedAlert.AlertTypeID == 3) {
				//
				//	Display Edit Popup
				//
				let popup_header = "Edit Special Alert";

				var ref = this.dialogService.open(EditSpecialAlertComponent, {
					header: popup_header,
					width: "880px",
					data: {
						UserID: this.user.userID,
						UserLevelID: this.user.UserLevelID,
						SchoolID: this.SelectedAlert.SchoolID,
						AlertID: this.SelectedAlert.AlertID,
					},
				});

				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh Q
						//
						this.onRefresh();
					}
				});
			}

			//
			//	Broadcast Alert
			//
			if (this.SelectedAlert.AlertTypeID == 4) {
				let parm: wsAlertMaintenanceBroadcastAlertUpdateValidateParm = {
					UserID: this.user.userID,
					AlertID: this.SelectedAlert.AlertID,
				};

				this.isBusy = true;
				this.dataService
					.AlertMaintenanceBroadcastAlertUpdateValidate(parm)
					.subscribe((data) => this.AlertMaintenanceBroadcastAlertUpdateValidate_Complete(data));
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertUpdateValidate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertUpdateValidate_Complete(data: any) {
		this.ErrorMessage = data[0];
		this.isBusy = false;

		if (this.ErrorMessage.length == 0) {
			//
			//	Display Edit Popup
			//
			let popup_header = "";

			if (this.SelectedAlert.DefinedByID == 4) {
				// District Level
				popup_header = "Edit Broadcast Alert - District Level";
			} else {
				popup_header = "Edit Broadcast Alert - School Level";
			}

			var ref = this.dialogService.open(EditBroadcastAlertComponent, {
				header: popup_header,
				width: "880px",
				data: {
					UserID: this.user.userID,
					UserLevelID: this.user.UserLevelID,
					AlertID: this.SelectedAlert.AlertID,
				},
			});

			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddIncident
	//
	//-----------------------------------------------------------------------------------------------------
	onAddIncident() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		let popup_header = "Add Incident Alert";

		var ref = this.dialogService.open(AddEditIncidentAlertComponent, {
			header: popup_header,
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				SchoolID: this.SelectedSchool.SchoolID,
				AlertID: -1,
				isAdd: true,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddEvent
	//
	//-----------------------------------------------------------------------------------------------------
	onAddEvent() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		let popup_header = "Add Event Alert";

		var ref = this.dialogService.open(AddEditEventAlertComponent, {
			header: popup_header,
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				SchoolID: this.SelectedSchool.SchoolID,
				AlertID: -1,
				isAdd: true,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddBroadcast
	//
	//-----------------------------------------------------------------------------------------------------
	onAddBroadcast() {
		this.ErrorMessage = "";

		let popup_header = "";

		if (this.user.UserLevelID == 1) {
			// District Level
			popup_header = "Add Broadcast Alert - District Level";
		} else {
			popup_header = "Add Broadcast Alert - School Level";
		}

		//
		//	Display Add Popup
		//
		var ref = this.dialogService.open(AddBroadcastAlertComponent, {
			header: popup_header,
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedAlert here. We don't unselect when selected.
		//
		this.SelectedAlert = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;

				if (isSchoolSelected == true) {
					this.onRefresh();
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
